export default "__VITE_ASSET__DLXLp$LM__"